import { digestPoints } from '@/mocks/home';

export default function DigestSection() {
  return (
    <section id="digest" className="w-full bg-background-100/70 border-y border-background-200/70 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.24em] text-primary-600">
              <span className="w-6 h-px bg-primary-400" />
              HOW WE DIG
            </span>
            <h2 className="mt-4 font-heading font-black text-foreground-950 text-3xl md:text-4xl tracking-tight leading-snug">
              深扒细节之前，
              <br />
              先说明我们怎么整理
            </h2>
            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-600">
              灵灵黑料被反复转述之后，细节最容易走样。所以这里只做三件事：
              留档、对齐、标注来源。判断留给看的人。
            </p>
            <a
              href="#timeline"
              className="mt-7 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-git-branch-line" />
              查看完整时间线
            </a>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            {digestPoints.map((d) => (
              <div
                key={d.id}
                className="bg-background-50 rounded-lg border border-background-200/80 p-5 md:p-6 flex flex-col"
              >
                <span className="w-11 h-11 rounded-lg bg-secondary-100 text-secondary-700 flex items-center justify-center">
                  <i className={`${d.icon} text-xl`} />
                </span>
                <h3 className="mt-5 font-heading font-bold text-foreground-950 text-lg">{d.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{d.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}